import React from 'react';
import { motion } from 'framer-motion';
export function FacilitySection() {
  return <section id="sede" className="py-24 bg-kiron-dark relative overflow-hidden" data-id="element-68">
      {/* Decorative background element */}
      <div className="absolute top-0 right-0 w-1/2 h-full bg-kiron-black clip-diagonal opacity-50 z-0" data-id="element-69"></div>

      <div className="max-w-7xl mx-auto px-6 relative z-10" data-id="element-70">
        <div className="flex flex-col lg:flex-row gap-12 items-center" data-id="element-71">
          <motion.div initial={{
          opacity: 0,
          x: -50
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6
        }} className="lg:w-1/3" data-id="element-72">
            <h2 className="text-4xl md:text-5xl font-oswald font-bold text-white mb-6 leading-tight" data-id="element-73">
              NUESTRA <br data-id="element-74" />
              <span className="text-kiron-teal" data-id="element-75">SEDE</span>
            </h2>
            <p className="text-xl text-gray-300 mb-8 font-light italic border-l-2 border-kiron-teal pl-4" data-id="element-76">
              "Un espacio diseñado para entrenar en serio."
            </p>
            <p className="text-gray-400 mb-8 font-light leading-relaxed" data-id="element-77">
              Equipamiento de primer nivel, zonas específicas para cada
              disciplina y un ambiente enfocado 100% en el rendimiento y la
              superación personal.
            </p>
            <a href="https://maps.app.goo.gl/63qKPXbZ4syc2dQs9" target="_blank" rel="noopener noreferrer" className="inline-block bg-transparent border-2 border-kiron-teal text-kiron-teal font-oswald font-bold text-lg px-8 py-4 uppercase tracking-wider hover:bg-kiron-teal hover:text-kiron-black transition-all duration-300" data-id="element-78">
              Conocé nuestras instalaciones
            </a>
          </motion.div>

          <div className="lg:w-2/3 grid grid-cols-1 md:grid-cols-2 gap-4 w-full" data-id="element-79">
            <motion.div initial={{
            opacity: 0,
            y: 30
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.6,
            delay: 0.2
          }} className="h-64 md:h-80 relative group overflow-hidden" data-id="element-80">
              <div className="absolute inset-0 bg-kiron-teal/20 group-hover:bg-transparent transition-colors duration-500 z-10" data-id="element-81"></div>
              <img src="https://cdn.magicpatterns.com/uploads/cgGrM6vDonxc8zFpe3vS4R/SaveClip.App_618144395_17872768035508306_3873199516963268169_n.jpg" alt="Kiron Gym Weights Area" className="w-full h-full object-cover grayscale group-hover:grayscale-0 transition-all duration-700 scale-105 group-hover:scale-100" data-id="element-82" />
            </motion.div>

            <motion.div initial={{
            opacity: 0,
            y: 30
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.6,
            delay: 0.4
          }} className="h-64 md:h-80 relative group overflow-hidden md:mt-12" data-id="element-83">
              <div className="absolute inset-0 bg-kiron-teal/20 group-hover:bg-transparent transition-colors duration-500 z-10" data-id="element-84"></div>
              <img src="https://cdn.magicpatterns.com/uploads/5iS424GLfNat5cJvPPmK4Z/SaveClip.App_618736816_17872768044508306_362254212216313105_n.jpg" alt="Kiron Gym Functional Area" className="w-full h-full object-cover grayscale group-hover:grayscale-0 transition-all duration-700 scale-105 group-hover:scale-100" data-id="element-85" />
            </motion.div>
          </div>
        </div>
      </div>
    </section>;
}